import { useEffect, useRef } from "react";
import { Loader2, Send } from "lucide-react";

const ChatComposer = ({ value, onChange, onSend, disabled, sending, placeholder }) => {
    const taRef = useRef(null);

    // Auto-resize textarea up to ~4 lines.
    useEffect(() => {
        const el = taRef.current;
        if (!el) return;
        el.style.height = "auto";
        el.style.height = Math.min(el.scrollHeight, 110) + "px";
    }, [value]);

    const handleKey = (e) => {
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            if (!disabled && !sending) onSend();
        }
    };

    return (
        <form
            onSubmit={(e) => {
                e.preventDefault();
                if (!disabled && !sending) onSend();
            }}
            className="border-t border-brand-dark/10 bg-white px-3 py-3 flex items-end gap-2"
            data-testid="chat-composer"
        >
            <textarea
                ref={taRef}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                onKeyDown={handleKey}
                disabled={disabled || sending}
                placeholder={placeholder || "Ask about fencing, decks, driveways…"}
                rows={1}
                className="flex-1 resize-none bg-brand-offwhite border border-brand-dark/10 px-3 py-2 text-sm leading-snug text-brand-dark placeholder:text-brand-gray focus:border-brand-cyan focus:outline-none disabled:opacity-60 disabled:cursor-not-allowed"
                data-testid="chat-composer-input"
                maxLength={4000}
            />
            <button
                type="submit"
                disabled={disabled || sending || !value.trim()}
                className="shrink-0 h-10 w-10 inline-flex items-center justify-center bg-brand-coral text-white hover:bg-[#d04438] disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                aria-label="Send message"
                data-testid="chat-send-button"
            >
                {sending ? (
                    <Loader2 className="h-4 w-4 animate-spin" strokeWidth={2.25} />
                ) : (
                    <Send className="h-4 w-4" strokeWidth={2.25} />
                )}
            </button>
        </form>
    );
};

export default ChatComposer;
